import { Model } from '@vuex-orm/core'

export default class Note extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'meetinsight'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      event_id: this.attr(null),
      transcription_cues: this.attr(null),
      analysis_impossible: this.attr(null),
      reason_impossible: this.attr(null),
      analysis_data: this.attr(null),
      analysis: this.attr(null),
      start_date: this.attr(null),
      end_date: this.attr(null),
      duration: this.attr(null),
      max_participants: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Meetinsight.js